// extracted by mini-css-extract-plugin
export var box = "_6m-1";
export var checkboxRow = "_6m-8";
export var checked = "_6m-2";
export var descriptionSpacer = "_6m-a";
export var disabled = "_6m-3";
export var icon = "_6m-6";
export var input = "_6m-0";
export var labelSpacer = "_6m-9";
export var medium = "_6m-5";
export var small = "_6m-4";
export var text = "_6m-7";